export const STARTING_COUNTDOWN_SECONDS = 60;
export const RESEND_SMS_LIMIT = 3;
